import styled, { keyframes } from "styled-components";
import { setFlex } from "../variables/utils";
import { BREAKPOINTS, desktop } from "../variables/breakpoints";

const fadeOut = keyframes`
  0% {
    opacity: 0.7;
  }
  100% {
    opacity: 0.2;
  }
`;

export const FooterWrapper = styled.div`
  width: 100%;
`;

export const ButtonContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  width: 100%;
  margin-bottom: 1.25rem;
`;

export const Button = styled.button`
  background-color: ${props => props.$secondaryColor || "black"};
  color: ${props => props.$primaryColor || "white"};
  padding: 1.5rem 3.5rem;
  font-family: editorialnew-regular;
  min-width: 15vw;
  border-radius: 10px;
  border: none;
  font-size: 1rem;
  line-height: 1rem;
  cursor: pointer;
  ${props => props.$isWebGLAvailable && desktop};

  @media (max-width: ${BREAKPOINTS.xlm}px) {
    min-width: 10vw;
  }
`;

export const Content = styled.div`
  ${setFlex({})};
  margin-bottom: 2px;
`;

export const DropdownCreditsContainer = styled.div`
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  background-color: transparent;
  border-top: 1px solid ${props => props.$creditsColor || "black"};
  margin-top: 2rem;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`;

export const CreditsHeading = styled.h3`
  font-family: editorialnew-regular;
  text-transform: uppercase;
  color: ${props => props.$creditsColor};
  font-size: 1rem;
  line-height: 1rem;
  padding: 1rem 0;
  margin: 0;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;

  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    grid-template-columns: auto;
  }
`;

export const ContentCredits = styled.div`
  padding: 55px 20px 20px;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-left: 60px;
  }

  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding-left: 120px;
  }
`;

export const Category = styled.h3`
  font-family: editorialnew-regular;
  color: ${props => props.$creditsColor};
  font-size: 0.8rem;
  line-height: 0.8rem;
  text-transform: uppercase;
  margin: 16px 0;

  grid-column: 2 span;
`;

export const Title = styled.p`
  font-family: editorialnew-regular;
  color: ${props => props.$creditsColor};
  margin: 0px 6px 0px 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 140%;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
    text-align: center;
  }
`;

export const Name = styled.span`
  font-family: editorialnew-regular;
  color: ${props => props.$creditsColor};
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  line-height: 140%;
`;

export const Link = styled.a`
  font-family: editorialnew-regular;
  color: ${props => props.$creditsColor};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
`;

export const Icon = styled.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
})``;

export const Chevron = styled(Icon)`
  path {
    stroke: ${props => props.$creditsColor};
  }
  transform: rotate(90deg);
  width: 32px;
  height: 32px;
  opacity: 0.7;

  animation: 1s ${fadeOut} infinite alternate;
`;
